import { createAction, props } from '@ngrx/store';
export const setFundChartSecuritylistSecurityId = createAction('[Fund Chart] Set security list security id', props());
